import { combineReducers } from "redux";
import rootSlice from "./rootSlice";
import settingsSlice from "./settingsSlice";

export default combineReducers({
  root: rootSlice,
  settings: settingsSlice,
});
